<template>
  <donut-form class="f-v f-ast" method="put" :action="`/${tag.route_flow_type}/tags/${tag.id}`">
    <donut-modal-sections-title title="Unarchive Journey" />
    <div class="t">Are you sure you want to unarchive {{ tag.name }}?</div>
    <input type="hidden" name="onboarding_tag[active]" :value="true">
    <donut-modal-sections-actions
      button-text="Unarchive"
      :is-form="true"
    />
  </donut-form>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const tag = computed(() => state.modal.data.tag);
</script>
